import { PointSystem } from "../leaderboards/PointSystem";

export const pointSystem: PointSystem = {
    kills: 3,
    placements: [
        {
            placement: 1,
            points: 30
        },
        {
            placement: 2,
            points: 27
        },
        {
            placement: 3,
            points: 25
        },
        {
            placement: 4,
            points: 24
        },
        {
            placement: 5,
            points: 23
        },
        {
            placement: 6,
            points: 22
        },
        {
            placement: 7,
            points: 21
        },
        {
            placement: 8,
            points: 20
        },
        {
            placement: 9,
            points:19
        },
        {
            placement: 10,
            points: 18
        },
        {
            placement: 11,
            points: 17
        },
        {
            placement: 12,
            points: 16
        },
        {
            placement: 13,
            points: 15
        },
        {
            placement: 14,
            points: 14
        },
        {
            placement: 15,
            points: 13
        },
        {
            placement: 16,
            points: 12
        },
        {
            placement: 17,
            points: 11
        },
        {
            placement: 18,
            points: 10
        },
        {
            placement: 19,
            points: 9
        },
        {
            placement: 20,
            points: 8
        },
        {
            placement: 21,
            points: 7
        },
        {
            placement: 22,
            points: 6
        },
        {
            placement: 23,
            points: 5
        },
        {
            placement: 24,
            points: 4
        },
        {
            placement: 25,
            points: 3
        },
        {
            placement: 26,
            points: 3
        },
        {
            placement: 27,
            points: 2
        },
        {
            placement: 28,
            points: 2
        },
        {
            placement: 29,
            points: 2
        },
        {
            placement: 30,
            points: 1
        },
        {
            placement: 31,
            points: 1
        },
        {
            placement: 32,
            points: 1
        }
    ]
}
